module.exports = __webpack_public_path__ + "img/yext.bc7aa8d5.svg";